module.exports = __webpack_public_path__ + "img/A3.486e2347.jpg";